//new style
import axios from "axios";
import WebCam from "../components/WebCam";
import { useState, useEffect } from "react";
import API from "../api";

export default function Add() {

  const [people, setPeople] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/people`)
      .then(res => setPeople(res.data))
      .catch(err => console.log(err));
  }, []);

  const [form, setForm] = useState({
    name: "",
    amount: "",
    date: "",
    referrer: "",
    investor: "",
    mobile: "",
    notes: ""
  });

  const [profileFile, setProfileFile] = useState(null);
  const [idFile, setIdFile] = useState(null);

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const referrers = people.filter(p => p.role === "referrer");
  const investors = people.filter(p => p.role === "investor");

  // SEND OTP
  const sendOtp = async () => {

    try {

      if (!form.mobile) {
        alert("Enter mobile number");
        return;
      }

      setLoading(true);

      await axios.post(`${API}/api/otp/send`, {
        mobile: form.mobile
      });

      setOtpSent(true);

      alert("OTP sent on WhatsApp");

    } catch (err) {

      console.log(err);

      alert(
        err?.response?.data?.message ||
        "Failed to send OTP"
      );

    } finally {
      setLoading(false);
    }
  };

  // VERIFY OTP
  const verifyOtp = async () => {

    try {

      const res = await axios.post(
        `${API}/api/otp/verify`,
        {
          mobile: form.mobile,
          otp
        }
      );

      if (res.data.success) {

        setVerified(true);

        alert("Mobile Verified");

      } else {

        alert("Invalid OTP");

      }

    } catch (err) {

      console.log(err);

      alert("OTP Verification Failed");

    }
  };

  // SUBMIT
  const handleSubmit = async () => {

    try {

      if (!verified) {
        alert("Verify mobile number first");
        return;
      }

      const formData = new FormData();

      formData.append("name", form.name);
      formData.append("amount", form.amount);
      formData.append("date", form.date);
      formData.append("referrer", form.referrer);
      formData.append("investor", form.investor);
      formData.append("mobile", form.mobile || "");
      formData.append("notes", form.notes || "");

      if (profileFile) {
        formData.append(
          "profilePhoto",
          profileFile
        );
      }

      if (idFile) {
        formData.append(
          "idPhoto",
          idFile
        );
      }

      await axios.post(
        `${API}/api/transactions`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      alert("Saved Successfully");

      setForm({
        name: "",
        amount: "",
        date: "",
        referrer: "",
        investor: "",
        mobile: "",
        notes: ""
      });

      setOtp("");
      setOtpSent(false);
      setVerified(false);

      setProfileFile(null);
      setIdFile(null);

    } catch (err) {

      console.log(err);

      alert("Save failed");

    }
  };

  return (
    <div className="min-h-screen bg-[#f4f7fb] pb-24">

      {/* HEADER */}
      <div className="bg-white px-5 pt-6 pb-4 shadow-sm rounded-b-3xl">
        <div className="flex items-center justify-between">

          <div>
            <h1 className="text-2xl font-bold text-slate-800">
              Add New Entry
            </h1>

            <p className="text-sm text-slate-500 mt-1">
              Create customer transaction
            </p>
          </div>

          <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-xl">
            👨
          </div>

        </div>
      </div>

      <div className="p-4">

        {/* MAIN CARD */}
        <div className="bg-white rounded-3xl shadow-sm p-5">

          {/* NAME */}
          <div className="mb-4">
            <label className="text-sm font-semibold text-slate-700">
              Customer Name
            </label>

            <input
              value={form.name}
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              placeholder="Enter customer name"
              onChange={e =>
                setForm({
                  ...form,
                  name: e.target.value
                })
              }
            />
          </div>

          {/* AMOUNT */}
          <div className="mb-4">
            <label className="text-sm font-semibold text-slate-700">
              Loan Amount
            </label>

            <input
              value={form.amount}
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              type="number"
              placeholder="Enter amount"
              onChange={e =>
                setForm({
                  ...form,
                  amount: e.target.value
                })
              }
            />
          </div>

          {/* DATE */}
          <div className="mb-5">
            <label className="text-sm font-semibold text-slate-700">
              Date
            </label>

            <input
              value={form.date}
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              type="date"
              onChange={e =>
                setForm({
                  ...form,
                  date: e.target.value
                })
              }
            />
          </div>

          {/* MOBILE OTP */}
          <div className="bg-slate-50 border border-slate-200 rounded-3xl p-4 mb-5">

            <h2 className="font-bold text-slate-800 mb-3">
              Mobile Verification
            </h2>

            <input
              value={form.mobile}
              className="w-full bg-white border border-slate-200 rounded-2xl px-4 py-3 outline-none mb-3"
              type="number"
              placeholder="Enter mobile number"
              onChange={e =>
                setForm({
                  ...form,
                  mobile: e.target.value
                })
              }
            />

            {!verified && (
              <button
                type="button"
                onClick={sendOtp}
                disabled={loading}
                className="w-full bg-blue-700 hover:bg-blue-800 transition text-white rounded-2xl py-3 font-medium"
              >
                {loading ? "Sending..." : "Send WhatsApp OTP"}
              </button>
            )}

            {otpSent && !verified && (
              <div className="mt-4">

                <input
                  value={otp}
                  className="w-full bg-white border border-slate-200 rounded-2xl px-4 py-3 outline-none mb-3"
                  placeholder="Enter OTP"
                  onChange={e =>
                    setOtp(e.target.value)
                  }
                />

                <button
                  type="button"
                  onClick={verifyOtp}
                  className="w-full bg-green-600 hover:bg-green-700 transition text-white rounded-2xl py-3 font-medium"
                >
                  Verify OTP
                </button>

              </div>
            )}

            {verified && (
              <div className="bg-green-100 text-green-700 px-4 py-3 rounded-2xl font-semibold mt-3">
                ✓ Mobile Verified Successfully
              </div>
            )}

          </div>

          {/* REFERRER */}
          <div className="mb-4">
            <label className="text-sm font-semibold text-slate-700">
              Select Referrer
            </label>

            <select
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              value={form.referrer}
              onChange={e =>
                setForm({
                  ...form,
                  referrer: e.target.value
                })
              }
            >
              <option value="">
                Select Referrer
              </option>

              {referrers.map(p => (
                <option
                  key={p._id}
                  value={p._id}
                >
                  {p.name}
                </option>
              ))}
            </select>
          </div>

          {/* INVESTOR */}
          <div className="mb-4">
            <label className="text-sm font-semibold text-slate-700">
              Select Investor
            </label>

            <select
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              value={form.investor}
              onChange={e =>
                setForm({
                  ...form,
                  investor: e.target.value
                })
              }
            >
              <option value="">
                Select Investor
              </option>

              {investors.map(p => (
                <option
                  key={p._id}
                  value={p._id}
                >
                  {p.name}
                </option>
              ))}
            </select>
          </div>

          {/* NOTES */}
          <div className="mb-5">
            <label className="text-sm font-semibold text-slate-700">
              Notes
            </label>

            <textarea
              value={form.notes}
              className="w-full mt-2 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 outline-none"
              rows={4}
              placeholder="Add notes"
              onChange={e =>
                setForm({
                  ...form,
                  notes: e.target.value
                })
              }
            />
          </div>

          {/* PROFILE PHOTO */}
          <div className="mb-5">

            <h3 className="font-bold text-slate-800 mb-3">
              Profile Photo
            </h3>

            <div className="bg-slate-50 rounded-3xl p-4 border border-slate-200">

              <WebCam
                onCapture={(img) => {

                  fetch(img)
                    .then(res => res.blob())
                    .then(blob => {

                      const file = new File(
                        [blob],
                        "profile.jpg",
                        {
                          type: "image/jpeg"
                        }
                      );

                      setProfileFile(file);

                    });

                }}
              />

              {profileFile && (
                <img
                  src={URL.createObjectURL(profileFile)}
                  alt=""
                  className="mt-4 w-24 h-24 object-cover rounded-2xl"
                />
              )}

            </div>

          </div>

          {/* ID PHOTO */}
          <div className="mb-6">

            <h3 className="font-bold text-slate-800 mb-3">
              Upload ID Card
            </h3>

            <div className="bg-slate-50 rounded-3xl p-4 border border-slate-200">

              <input
                type="file"
                accept="image/*"
                onChange={(e) => {

                  const file = e.target.files[0];

                  if (file) {
                    setIdFile(file);
                  }

                }}
              />

              {idFile && (
                <img
                  src={URL.createObjectURL(idFile)}
                  alt=""
                  className="mt-4 w-24 h-24 object-cover rounded-2xl"
                />
              )}

            </div>

          </div>

          {/* SAVE */}
          <button
            disabled={!verified}
            onClick={handleSubmit}
            className={`w-full py-4 rounded-2xl font-semibold text-white transition ${
              verified
                ? "bg-blue-700 hover:bg-blue-800"
                : "bg-slate-400"
            }`}
          >
            Save Entry
          </button>

        </div>

      </div>

    </div>
  );
}